import { render, staticRenderFns } from "./UCButtonGroup.vue?vue&type=template&id=5c6602a3&scoped=true&"
import script from "./UCButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./UCButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./UCButtonGroup.vue?vue&type=style&index=0&id=5c6602a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6602a3",
  null
  
)

export default component.exports